import { useTranslations } from "next-intl";
import { montserrat } from "utils";

export function AdvanceFeePopoverContent() {
  const t = useTranslations();

  const optionClassName = "flex flex-row items-center gap-2";
  return (
    <div className="p-2 rounded-xl max-w-[32rem]">
      <p>{t("Pricing.popover.advanceFeeTopDescription")}</p>
      <ul>
        <li className={optionClassName}>
          <span className="text-base">✔️</span>
          <span className={`${montserrat.className} text-base`}>
            {t("Pricing.popover.advanceFeeOptionFirst")}
          </span>
        </li>
        <li className={optionClassName}>
          <span className="text-base">✔️</span>
          <span className={`${montserrat.className} text-base`}>
            {t("Pricing.popover.advanceFeeOptionSecond")}
          </span>
        </li>
        <li className={optionClassName}>
          <span className="text-base">❌</span>
          <span className={`${montserrat.className} text-base`}>
            {t("Pricing.popover.advanceFeeOptionThird")}
          </span>
        </li>
      </ul>
      <p>{t("Pricing.popover.advanceFeeBottomDescription")}</p>
    </div>
  );
}
